module.exports = __webpack_public_path__ + "img/hello.7816fe8c.png";